import { RmsAccountBadgeColumns } from '@/backend/features/badging/badging-customizations/entities/rmsAccountBadgeEntityTypes';
import { AccountBadgeColumns } from '@juvare/badging/backend/features/badges/shared';
import { AccountBadgeNameCell } from '@juvare/badging/ui/features/badge-management/components/AccountBadgeTable/AccountBadgeNameCell';
import { Column } from '@juvare/common-data-table-ui/DataTable';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { SystemRoleMap } from '@juvare/contact-management/backend/features/permissions/shared';
import { Row } from '@juvare/platform-shared/features/storage';
import { Box, Stack, Typography } from '@mui/material';
import { TFunction } from 'i18next';
import React from 'react';

export const extendAccountBadgeTableColumns = (
    defaultColumns: Column<Row<AccountBadgeColumns>>[],
    t: TFunction<'rms'>,
    systemRoleMap: SystemRoleMap,
) =>
    [
        {
            headerLabel: t('badging.accountBadgeTable.columnHeaders.badgeName'),
            sortKey: 'fullName',
            cellFunction: (row: Row<RmsAccountBadgeColumns>) => {
                const systemRoleLabel = systemRoleMap[row.columns.accountSystemRole as keyof typeof systemRoleMap].label;

                return (
                    <AccountBadgeNameCell
                        accountBadge={row}
                        descriptionContent={
                            <Stack
                                gap={1}
                                direction='row'
                                sx={{
                                    alignItems: 'center',
                                    minWidth: 0,
                                }}
                                divider={
                                    <Box
                                        sx={{
                                            backgroundColor: themeColors.icon.disable,
                                            width: '4px',
                                            height: '4px',
                                            borderRadius: 50,
                                            flexShrink: 0,
                                        }}
                                    />
                                }
                            >
                                {row.columns.occupationName && (
                                    <Typography variant='body2' color={themeColors.text.subtle}>
                                        {row.columns.occupationName}
                                    </Typography>
                                )}
                                <Typography variant='body2' color={themeColors.text.subtle}>
                                    {systemRoleLabel}
                                </Typography>
                            </Stack>
                        }
                    />
                );
            },
        },
        ...defaultColumns.slice(1),
    ] as Column<Row<AccountBadgeColumns>>[];
